import { render, staticRenderFns } from "./DistributionList.vue?vue&type=template&id=0d072d0a&scoped=true&"
import script from "./DistributionList.vue?vue&type=script&lang=js&"
export * from "./DistributionList.vue?vue&type=script&lang=js&"
import style0 from "./DistributionList.vue?vue&type=style&index=0&id=0d072d0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d072d0a",
  null
  
)

export default component.exports